import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FsAttachmentService } from '../../services/api/fs-attachment.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-icam-file-downloader',
  templateUrl: './icam-file-downloader.component.html',
  styleUrl: './icam-file-downloader.component.scss'
})
export class IcamFileDownloaderComponent {
  @Input() templateId?: string;
  @Input() fileName?: string;

  isDownloading = false;

  constructor(private fsAttachmentService: FsAttachmentService, private _cdr: ChangeDetectorRef) {}

  downloadTemplate(): void {
    if (!this.templateId || this.isDownloading) {
      return;
    }

    this.isDownloading = true;

    this.fsAttachmentService
      .downloadFile(this.templateId, this.fileName)
      .pipe(
        finalize(() => {
          this.isDownloading = false;
          this._cdr.markForCheck();
        }),
        catchError(() => of(null))
      )
      .subscribe();
  }

  get isDownloadDisabled(): boolean {
    return !this.templateId || this.isDownloading;
  }

  get displayFileName(): string {
    return this.fileName || 'Template';
  }
}
